import React from 'react';
import { Typography } from "../ecosystem";

const ErrorLoadingTileMessage = ({
    errorMsg
}) => {

    return (
        <div className="error-loading-tile-msg">
            <Typography
                color="$color-system-b1"
                type="body-02"
                tag="div"
            >
                {errorMsg ? errorMsg : "Not available. Please try again later."}
            </Typography>
        </div>
    );
}

export default ErrorLoadingTileMessage;
